module.exports = '<svg width="33" height="32" viewBox="0 0 33 32"><path d="M16.444 6.878V2.057c0-2.044-1.227-2.672-2.712-1.389L.556 12.005c-.747.642-.744 1.678.003 2.317l13.18 11.34c1.478 1.277 2.705.652 2.705-1.392v-4.525h3.291c5.782 1.043 9.27 6.21 11.439 11.623.339.846.833.846 1.066-.036a19.43 19.43 0 0 0 .658-5.005c0-9.784-7.121-17.882-16.454-19.449z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/reply-1.js
// module id = 1372
// module chunks = 14